import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Building } from '../model/building.model';
import { selectIsOffline } from '../../network/store/network.selector';
import { selectHasPolicy } from '../../authentication/store/user.selector';
import { Control, ControlDetails } from '../../control/model/control.model';
import { selectBuilding } from '../store/building.selector';
import { selectOngoingControl } from '../../control/store/control.selector';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ControlReportComponent } from '../../control/control-report/control-report.component';
import { SecondaryButtonComponent } from '../../shared/buttons/secondary-button.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-batch-control-edit-dialog',
  templateUrl: './batch-control-edit-dialog.component.html',
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    ControlReportComponent,
    MatDialogActions,
    SecondaryButtonComponent,
    TranslocoPipe,
    AsyncPipe,
  ],
})
export class BatchControlEditDialogComponent {
  offline$ = this.store.select(selectIsOffline);
  hasControlBatchGetPolicy$ = this.store.select(selectHasPolicy('control.batch.get'));
  building$ = this.store.select(selectBuilding);
  control$ = this.store.select(selectOngoingControl);

  readonly building?: Building;
  readonly control?: Control;
  readonly count: number;

  constructor(
    private dialogRef: MatDialogRef<BatchControlEditDialogComponent, ControlDetails>,
    private store: Store,
    @Inject(MAT_DIALOG_DATA) private data: { count: number }
  ) {
    this.count = this.data.count ?? 1;
  }

  close() {
    this.dialogRef.close();
  }
}
